export default {
  index: 0,
  auth: {
    isLogin: true,
    isDone: false
  },
  cart: {
    woa: [],
    weibo: [],
    video: [],
    live: [],
    xhs: [],
    news: [],
  },
  cartLoading: false,
  cartTaxonomy: 'woa',
  customerService: {},
  taxonomy: {
    // news: '软文推广',
    xhs: '小红书',
    video: '短视频',
    woa: '微信公众号',
    weibo: '新浪微博',
    live: '网红直播',

    //flow: '信息流',
  },
  ownActive: 'order',
  _profile: {
    name: '-',
    connect: {},
    company: {},
    agency: {},
    attribute: {
      taxonomies: []
    }
  },
  profile: {
    name: '-',
    connect: {},
    company: {},
    price_level: {},
    agency: {},
    attribute: {
      taxonomies: []
    }
  },
  basicTaxonomy: [],
  zimeitiTypeIcons: {
    "百家号": "http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/uploads/editor/20240802/1722579210519441.jpg",
    "今日头条": "http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/uploads/editor/20240802/1722579238391633.jpg",
    "新浪网": "http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/uploads/editor/20240802/1722579367195067.jpg",
    "搜狐网": "http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/uploads/editor/20240802/1722594541596923.jpg",
    "腾讯网": "http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/uploads/editor/20240802/1722579406139985.jpg",
    "网易": "http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/uploads/editor/20240802/1722579423956853.jpg",
    "凤凰网": "http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/uploads/editor/20240802/1722579449386321.jpg",
    "知乎": "http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/uploads/editor/20240802/1722579466702118.jpg",
    "ZAKER": "http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/uploads/editor/20240802/1722579657561415.jpg",
    "一点资讯": "http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/uploads/editor/20240802/1722579687400100.jpg",
    "东方财富": "http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/uploads/editor/20240802/1722579730901201.jpg",
    "汽车之家": "http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/uploads/editor/20240802/1722579749416809.jpg",
    "中金在线": "http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/uploads/editor/20240802/1722580196389584.jpg",
    "雪球网": "http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/uploads/editor/20240802/1722579784368560.jpg",
    "豆瓣": "http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/uploads/editor/20240802/1722579804369909.jpg",
    "UC号": "http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/uploads/editor/20240802/1722579804369909.jpg",
    "其他": "http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/uploads/editor/20240802/1722580456883537.jpg",
    "微信公众号": "http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/uploads/editor/20240802/1722579872362915.jpg",
    "视频号": "http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/uploads/editor/20240802/1722579872362915.jpg",
    "微博": "http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/uploads/editor/20240802/1722579966314071.jpg",
    "小红书": "http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/uploads/editor/20240802/1722579979451819.jpg",
    "抖音号": "http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/uploads/editor/20240802/1722579994109983.jpg",
    "快手号": "http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/uploads/editor/20240802/1722580008759993.jpg",
    "西瓜视频": "http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/uploads/editor/20240802/1722580024983891.jpg",
    "哔哩哔哩": "http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/uploads/editor/20240802/1722580051519282.jpg",

  }
}



// WEBPACK FOOTER //
// ./src/vuex/state.js